import { v4 as uuidv4 } from 'uuid';
import { localStorage } from './BrowserHelpers';
var isAvailableState = null; // Inspired by Modernizr

export function isAvailable() {
  if (isAvailableState !== null) {
    return isAvailableState;
  }

  if (!localStorage) {
    return isAvailableState = false;
  }

  var key = uuidv4();

  try {
    localStorage.setItem(key, key);
    localStorage.removeItem(key);
    return isAvailableState = true;
  } catch (e) {
    return isAvailableState = false;
  }
}
export function setItem(key, value) {
  if (isAvailable()) {
    return localStorage.setItem(key, value);
  } else {
    throw 'Unavailable or unsuable localStorage';
  }
}
export function getItem(key) {
  if (isAvailable()) {
    return localStorage.getItem(key);
  } else {
    throw 'Unavailable or unsuable localStorage';
  }
}